// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"390":"7e2379da","963":"f7fdef67"}[chunkId] + ".chunk.js";
};